import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Input } from 'semantic-ui-react';

// Selectors
import { makeSelectEventValue } from '../../../../../../services/events/selectors';

// Environment
const { REACT_APP_URL } = process.env;

interface Props {
    uuid?: string;
}

export class EventShareUrlInput extends React.PureComponent<Props> {
    inputRef = React.createRef();

    get action() {
        if (document.queryCommandSupported('copy')) {
            return {
                color: 'primary',
                content: 'Copy',
                onClick: this.handleClick
            };
        }
        return undefined;
    }

    handleClick = () => {
        if (this.inputRef.current) {
            this.inputRef.current.select();
        }
        document.execCommand('copy');
    };

    render() {
        const { uuid } = this.props;
        if (!uuid) return null;
        return (
            <Input
                ref={this.inputRef}
                action={this.action}
                value={`${REACT_APP_URL}/shared-job/${uuid}`}
                fluid
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    uuid: makeSelectEventValue('uuid')
});

export default connect(mapStateToProps)(EventShareUrlInput);
